import { markAsCompleted } from './_core'

/**
 * Doc: https://usefulangle.com/post/113/javascript-detecting-element-visible-during-scroll
 * 
 * @param	{Object}	input	
 * @param	{Number}	input.duration
 * @param	{Function}	next	
 * @param	{Object}	context	
 * 
 * @return	{Void}
 */
export default function track(input, next, context) {
	try {
		const { debug } = context || {}
		const { id, duration:_duration } = input||{}
		if (debug)
			console.log(`INFO - Start tracking 'wait' event (id: ${id}, duration: ${_duration})`)
		const duration = (_duration||0)*1
		if (!duration || isNaN(duration) || duration < 0) {
			markAsCompleted(id, next, context)
			return 
		}

		setTimeout(() => {
			markAsCompleted(id, next, context)
		}, duration)
	} catch(err) {
		console.error(`ERROR - Failed to track 'wait' instruction. Details: ${err.stack||err.message}`)
	}
}